import Translator from './../translator';

export default {
  selector: '.js-form-validate',
  fieldClass: 'form__entry__input--error',
  errorClass: 'form__entry__errormessage',
  messageValueMissing: Translator.trans('validator.messageValueMissing'),
  messageValueMissingCheckbox: Translator.trans('validator.messageValueMissingCheckbox'),
  messageValueMissingRadio: Translator.trans('validator.messageValueMissingRadio'),
  messageValueMissingSelect: Translator.trans('validator.messageValueMissingSelect'),
  messageValueMissingSelectMulti: Translator.trans('validator.messageValueMissingSelectMulti'),
  messageTypeMismatchEmail: Translator.trans('validator.messageTypeMismatchEmail'),
  messageTypeMismatchURL: Translator.trans('validator.messageTypeMismatchURL'),
  messageTooShort: Translator.trans('validator.messageTooShort'),
  messageTooLong: Translator.trans('validator.messageTooLong'),
  messagePatternMismatch: Translator.trans('validator.messagePatternMismatch'),
  messageBadInput: Translator.trans('validator.messageBadInput'),
  messageStepMismatch: Translator.trans('validator.messageStepMismatch'),
  messageRangeOverflow: Translator.trans('validator.messageRangeOverflow'),
  messageRangeUnderflow: Translator.trans('validator.messageRangeUnderflow'),
  messageGeneric: Translator.trans('validator.messageGeneric'),
};
